import { Injectable } from '@angular/core';
import { InjectorService } from '../../services/injector.service';
import { MotiveComponent } from './motive.component';

@Injectable()
export class MotiveService {
  constructor(
    private injector: InjectorService
  ) { }

  addMotive(motiveType) {
    const dialog = this.injector.getComponent<MotiveComponent>('MOTIVE.ADDMOTIVE', MotiveComponent);
    dialog.type = motiveType;
      dialog.cardDataExtra = null;
    return dialog.show()
  }

  addMotiveCard(motiveType, cardData) {
    const dialog = this.injector.getComponent<MotiveComponent>('MOTIVE.ADDMOTIVE', MotiveComponent);
    dialog.type = motiveType;
    dialog.cardDataExtra = cardData;
    return dialog.show()
  }
}
